import React from 'react';
import { func, object, string } from 'prop-types';
import { useHistory } from 'react-router-dom';
import NotificationCard from '../index';

const Mentions = ({ notification, shortCode, refetch, applyOptimisticUpdate }) => {
  const { metadata } = notification;
  const { author, invoice, isMultiInvoice, contact, noteHash } = metadata;
  const history = useHistory();

  function getSubtitle() {
    if (isMultiInvoice) {
      return `${contact?.Name} for multiple invoices`;
    }
    if (invoice?.InvoiceNumber) {
      return `${contact?.Name} for invoice ${invoice?.InvoiceNumber}`;
    }
    return contact?.Name;
  }

  function getLink() {
    const hash = noteHash ? `#note~${noteHash}` : '';

    if (isMultiInvoice) {
      return contact?.ContactID ? `/receivables/customer/${contact.ContactID}${hash}` : '/receivables';
    }
    if (invoice?.InvoiceNumber) {
      return invoice?.InvoiceID ? `/receivables/invoice/${invoice.InvoiceID}${hash}` : '/receivables';
    }
    return contact?.ContactID ? `/receivables/customer/${contact.ContactID}${hash}` : '/receivables';
  }

  const fullName = author
    ? `${author?.profile?.firstName || ''} ${author?.profile?.lastName || ''}`.trim()
    : 'Deleted user';

  const name = fullName.length > 13 ? `${fullName.substring(0, 13)}...` : fullName;

  return (
    <NotificationCard
      notification={notification}
      shortCode={shortCode}
      refetch={refetch}
      applyOptimisticUpdate={applyOptimisticUpdate}
      onClick={() => history.push(getLink())}
      title={`${name} has mentioned you in a note`}
      subtitle={getSubtitle()}
    />
  );
};

export default Mentions;

Mentions.propTypes = {
  shortCode: string.isRequired,
  notification: object.isRequired,
  applyOptimisticUpdate: func.isRequired,
  refetch: func.isRequired,
};
